var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgMore = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { fill: "currentColor", d: "M2.883 7.625a1.375 1.375 0 1 1 0 2.75 1.375 1.375 0 0 1 0-2.75m6.117 0a1.375 1.375 0 1 1 0 2.75 1.375 1.375 0 0 1 0-2.75m6.118 0a1.375 1.375 0 1 1-.001 2.75 1.375 1.375 0 0 1 0-2.75" }) }))); };
export default SvgMore;
